import React from 'react'
import './header.css'
import CTA from '../../components/cta/CTA';
import Social from '../social/Social';
import Me from '../../assets/me.png'



const Header = () => {
  return (
    <header>
      <div className="container container__header">
        <h5>Hello, I am</h5>
        <h1>Facinet Camara</h1>
        <h5 className="text-muted">
          Full Stack Developer 
        </h5>
        <CTA/>
        <div className="me">
          <img src={Me} alt="facinet" />
        </div>

        <a href="#contact" className='scroll__down'>Scroll Down</a>
        <Social/>
      
      </div>
      
    </header>
  )
}

export default Header